var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGestionAlerta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_235_13340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 6,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1403 13.8667V10.9445C11.1403 9.0219 9.57646 7.46154 7.65039 7.46154C5.72432 7.46154 4.16047 9.0219 4.16047 10.9445V13.8667L3.09817 16.5172H12.2096L11.1473 13.8667H11.1403ZM10.3462 17.9104C10.0362 19.112 8.94604 20.0002 7.6469 20.0002C6.34776 20.0002 5.2576 19.112 4.94762 17.9104H1.0293L2.76033 13.595V10.9445C2.76033 8.25217 4.94761 6.06836 7.6469 6.06836C10.3462 6.06836 12.5335 8.25217 12.5335 10.9445V13.595L14.2645 17.9104H10.3462ZM6.4418 17.9104C6.68213 18.3284 7.13143 18.607 7.6469 18.607C8.16238 18.607 8.61169 18.3284 8.85201 17.9104H6.43832H6.4418Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_235_13340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0102 4.32715H-0.708008V21.7419H16.0102V4.32715Z",
    fill: "#3F3065"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_235_13340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 2,
    width: 5,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7599 7.39962C13.991 7.39962 14.989 6.40161 14.989 5.17051C14.989 3.93941 13.991 2.94141 12.7599 2.94141C11.5288 2.94141 10.5308 3.93941 10.5308 5.17051C10.5308 6.40161 11.5288 7.39962 12.7599 7.39962Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_235_13340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8477 1.08398H8.67432V9.25737H16.8477V1.08398Z",
    fill: "#3F3065"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_235_13340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 5,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2291 7.39962C3.46021 7.39962 4.45821 6.40161 4.45821 5.17051C4.45821 3.93941 3.46021 2.94141 2.2291 2.94141C0.998004 2.94141 0 3.93941 0 5.17051C0 6.40161 0.998004 7.39962 2.2291 7.39962Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_235_13340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31694 1.08398H-1.85645V9.25737H6.31694V1.08398Z",
    fill: "#3F3065"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_235_13340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 5,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52305 4.45821C8.75415 4.45821 9.75215 3.46021 9.75215 2.2291C9.75215 0.998004 8.75415 0 7.52305 0C6.29195 0 5.29395 0.998004 5.29395 2.2291C5.29395 3.46021 6.29195 4.45821 7.52305 4.45821Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_235_13340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6109 -1.85742H3.4375V6.31596H11.6109V-1.85742Z",
    fill: "#3F3065"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGestionAlerta);
export default __webpack_public_path__ + "static/media/icon-gestion-alerta.dd76df9939a5650e29dc0cc19352b47b.svg";
export { ForwardRef as ReactComponent };